/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentReferencesFormReferenceTypes: "shipment-references-form-reference-types",
  shipmentReferencesFormReferenceNumber: "shipment-references-form-reference-number",
  shipmentReferencesFormRemoveReferenceNumber: "shipment-references-form-remove-reference-number",
  shipmentReferencesFormAddReferenceNumber: "shipment-references-form-add-reference-number",
} as const;
